/** High Altitude ticket label (same string as event summary / manifestTickets). */
export const HIGH_ALTITUDE_LABEL = 'High Altitude';

/** Jet add-on label — tracked like other offerings (purchased count only, no manifest "used"). */
export const JET_LABEL = 'Jet';

/** Purchased / demand only — no day-of manifest slot consumption ("used"). */
export function isDemandOnlyUsageLabel(label) {
  return label === HIGH_ALTITUDE_LABEL || label === JET_LABEL;
}

/**
 * Legacy: day-of purchase rows (previously in highAltitudeManifest) merged into flyer usage.
 * Kept for archived admin tool / old data; app UI no longer reads highAltitudeManifest.
 */
export function isPurchaseRowApplied(p) {
  return !!(p && (p.appliedToUsage || p.syncedToMoney));
}

/** Legacy HA purchased merge (manifestTickets + usage.purchased oddities). Prefer {@link purchasedForUsageLabel} in new code. */
export function effectiveHighAltitudePurchased(manifestTickets = {}, usageMap = {}) {
  const base = manifestTickets[HIGH_ALTITUDE_LABEL] || 0;
  const raw = usageMap[HIGH_ALTITUDE_LABEL]?.purchased;
  const p = typeof raw === 'number' && !Number.isNaN(raw) ? raw : 0;
  return base + Math.max(0, p - base);
}

/** Purchased total for a usage-tracked ticket label (Jet-style: usage.purchased or manifestTickets). */
export function purchasedForUsageLabel(flyer, label) {
  const manifest = (flyer.manifestTickets && flyer.manifestTickets[label]) || 0;
  const u = flyer.usage?.[label] || {};
  if (typeof u.purchased === 'number' && !Number.isNaN(u.purchased)) return u.purchased;
  return manifest;
}
